import React from 'react';

import ReceiptCard from '../share/ReceiptCard';
import { formatReceiptTimestamp, type ReceiptMoment } from '../../lib/share';

interface LatestMovementPanelProps {
  officialId: string;
  officialName: string;
  officeName: string;
  moment: ReceiptMoment;
  shareEnabled?: boolean;
  activeAnchorId?: string | null;
}

export default function LatestMovementPanel({
  officialId,
  officialName,
  officeName,
  moment,
  shareEnabled = false,
  activeAnchorId,
}: LatestMovementPanelProps) {
  return (
    <div className="mt-5 rounded-2xl border border-red-500/20 bg-red-500/5 p-4">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-2xl">
          <p className="text-[10px] font-black uppercase tracking-widest text-red-500">Latest movement</p>
          <h2 className="mt-2 text-lg font-black uppercase tracking-tight text-navy-900">
            {moment.claim}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-navy-600">{moment.summary}</p>
          <div className="mt-3 flex flex-wrap items-center gap-3 text-[11px] font-semibold text-navy-500">
            <span>{formatReceiptTimestamp(moment.occurredAt)}</span>
            <a href={`#${moment.anchorId}`} className="text-gold-600 hover:underline">
              Jump to evidence
            </a>
            {moment.evidenceUrl && (
              <a href={moment.evidenceUrl} target="_blank" rel="noopener noreferrer" className="text-gold-600 hover:underline">
                Open source
              </a>
            )}
          </div>
        </div>
        {shareEnabled && (
          <div className="w-full max-w-md shrink-0">
            <ReceiptCard
              officialId={officialId}
              officialName={officialName}
              officeName={officeName}
              moment={moment}
              shareEnabled
              active={activeAnchorId === moment.anchorId}
              compact
              anchorable={false}
            />
          </div>
        )}
      </div>
    </div>
  );
}
